module.exports = __webpack_public_path__ + "static/img/logo50.238e426.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo50.png
// module id = thJf
// module chunks = 1